<template>
  <div  class="card dash-card headercard"
        style="margin-top:2px; height:510px!important;"
        v-bind:style="{ height: getHeight(survey) }" >
    <LamboColumnHeaders :dashdata="dashdata"
                        :items="headerItems" />

    <lambo-digital  v-if="survey == '1090' || survey == '1091'" 
                    :dashdata="dashdata"
                    :survey="survey" />

    <span v-else></span>
  </div>
</template>

<script>
  import LamboColumnHeaders from './LamboColumnHeaders';
  import LamboDigital from './LamboDigital';
  import KpiMixin from '@/mixins/lambo/KpiMixin';

  export default {
    components: {
      LamboColumnHeaders,
      LamboDigital
    },
    props: {
      survey: String
    },
    data() {
      return {
        headerItems: [
          { kpi: '02. Personal Contact', classes: 'col-3' },
          { kpi: '03. Quality of Personal Contact', classes: 'col-3' },
          { kpi: '04. Appointment Making', classes: 'col-3' },
          { kpi: '05. Quality of Offer', classes: 'col-3' },
        ]
      }
    },
    mixins: [ KpiMixin ],
    methods: {
      getHeight(survey) {
        if (survey == '1090') return '510px';
        else return '700px';
      }
    }
  }
</script>

<style scoped>
  .dash-card >>> .kpitable {
    max-width: 208px;
  }
  
</style>
